import DataCenter from './root.vue'
import MainNav from './main_nav.vue'
import dataView from './data_view/router'
import goodsSale from './goods_sale/router'
import memberData from './member_data/router'
import fundReconciliation from './fund_reconciliation/router'
import liquidation from './fund_reconciliation/modules/liquidation/router'

const route = {
    path: 'dataCenter',
    component: DataCenter,
    children: [
        {
            path: '',
            redirect: 'nav'
        },
        {
            path: 'nav',
            component: MainNav,
            children: [
                {
                    path: '',
                    redirect: 'dataView'
                },
                dataView,
                goodsSale,
                memberData,
                fundReconciliation
            ]
        },
        liquidation
    ]
}

export default route
